import React, { useState, useEffect } from 'react';
const classNames = require('classnames');

const MIN = 0;
const MAX = 10;

export default function NPSForm(props) {
  const [value, setValue] = useState(null);

  useEffect(() => {
    const { score } = props;
    setValue(score);
  });

  function range(start, end) {
    return Array(end - start + 1)
      .fill()
      .map((_, idx) => start + idx);
  }

  function onMouseEnter(value) {
    setValue(value);
  }

  function onMouseLeave(value) {
    setValue(null);
  }

  function onSelect(value) {
    const { onSubmit } = props;
    onSubmit(value);
  }

  return (
    <div>
      <div className="NPSScale">
        <div className="NPSScale-Values">
          {range(MIN, MAX).map(i => (
            <div
              key={i}
              className={classNames('NPSScale-Value', {
                selected: value !== null && value >= i,
              })}
              onMouseEnter={() => onMouseEnter(i)}
              onMouseLeave={() => onMouseLeave(i)}
              onClick={() => onSelect(i)}
            >
              <div>{i}</div>
            </div>
          ))}
        </div>
        <div className="NPSScale-Legend">
          <div className="NPSScale-Label left">Not at all likely</div>
          <div className="NPSScale-Label right">Extremely likely</div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/nps-input/NPSScale.js